export const contentCardWidthPx = 265
